<gl-base-modal [disableCloseButton]="true">
  <h2 class="title">{{ 'complete_profile_details_header' | translate }}</h2>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form rolesEmailPopup">
    @if (true) {
      <div class="roles">
        @for (role of roles; track role) {
          <gl-radio-button formControlName="role" [value]="role">{{
            role | translate
          }}</gl-radio-button>
        }
      </div>
    }
    @if (!this.user.email) {
      <div class="input-container">
        <gl-input-container>
          <input type="text" normal-input formControlName="email" placeholder="Email" />
        </gl-input-container>
      </div>
    }
    @if (true) {
      <div class="passwords">
        <p class="newLoginMethodInfo">{{ 'new_login_method_info' | translate}}</p>
        <gl-input-container [errorAboveInput]="true">
          <input
            type="password"
            placeholder="password_with_hint"
            normal-input
            formControlName="password"
            />
        </gl-input-container>
        <gl-input-container [errorAboveInput]="true">
          <input
            type="password"
            placeholder="repeat_password"
            normal-input
            formControlName="retypedPassword"
            />
        </gl-input-container>
      </div>
    }
    @if (true) {
      <gl-checkbox formControlName="acceptedTermsOfServiceAndPrivacyPolicy" [defaultChecked]="false">
        <p class="rules-and-policy">
          {{ 'declare_rules_privacy_policy_message' | translate }}
          <a (click)="goTo($event, regulationsLink)" normal-link>{{ 'declare_rules' | translate }}</a>
          {{ 'and' | translate }}
          <a (click)="goTo($event, privacyPolicyLink)" normal-link>{{
            'declare_privacy_policy' | translate
            }}</a
            >{{ 'declare_rules_privacy_policy_message_end' | translate }}.
          </p>
        </gl-checkbox>
      }
      <div class="buttons">
        <button normal-outline-button type="submit">{{ 'save' | translate }}</button>
      </div>
    </form>
  </gl-base-modal>
